import { Grid } from '@kirz/mui-admin';
import {
  Button,
  CardContent,
  Container,
  Typography,
  Card,
  useTheme,
} from '@mui/material';
import React, { useContext } from 'react';

import { PngCompanyLogo } from 'components/PngCompanyLogo';
import { WebFormContext } from 'contexts/WebFormContext';

export default function Introduction() {
  const theme = useTheme();
  const { form, setStep } = useContext(WebFormContext);

  return (
    <Container maxWidth="sm">
      <Card
        elevation={10}
        sx={{
          borderRadius: 4,
          px: { xs: 2, sm: 6 },
          py: { xs: 2, sm: 2 },
        }}
      >
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <PngCompanyLogo
            htmlColor={theme.palette.brand.main}
            sx={{
              width: 250,
              mb: 2,
            }}
          />
          <Typography
            component="h4"
            sx={{
              textAlign: 'center',
              mb: 1,
              fontSize: '1.5rem',
            }}
          >
            {form.name}
          </Typography>
          <Typography
            variant="body2"
            sx={{ textAlign: 'center', color: 'text.secondary', mb: 3 }}
          >
            Ter voorbereiding van de aangifte in de personenbelasting vragen wij
            u vriendelijk om dit formulier zo nauwgezet mogelijk in te vullen.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            sx={{ mt: 2, px: 5 }}
            onClick={() => setStep((x) => x + 1)}
          >
            Begin
          </Button>
        </CardContent>
      </Card>
    </Container>
  );
}
